import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"filter-2, sort"} maskId="square-filled-radius-0-stroke-1-IconFilter2"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V5H2V4ZM5 11.5H19V12.5H5V11.5ZM8 19H16V20H8V19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFilter2;
